<template>
  <v-text-field
    v-bind="$props"
    v-on="$listeners"
  >
    <slot
      v-for="(_, name) in $slots"
      :name="name"
      :slot="name"
    />
    <template
      v-for="(_, slot) of $scopedSlots"
      slot-scope="scope"
    >
      <slot
        :name="slot"
        v-bind="scope"
      />
    </template>
    <template #append-outer>
      <div
        v-if="$slots['append-outer']"
        class="inputBg rounded-r"
        style="margin-left: -9px; margin-top: -7px;"
      >
        <slot name="append-outer"></slot>
      </div>
    </template>
  </v-text-field>
</template>

<script>
  import {
    VTextField,
  } from 'vuetify/lib';

  export default {
    name: 'AppTextField',

    extends: VTextField,

    props: {
      backgroundColor: {
        type: String,
        default: 'inputBg',
      },
      dense: {
        type: Boolean,
        default: true,
      },
      flat: {
        type: Boolean,
        default: true,
      },
      solo: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>